import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-permission-group-dialog',
  templateUrl: './permission-group-dialog.component.html',
  styleUrls: ['./permission-group-dialog.component.scss'],
})
export class PermissionGroupDialogComponent {
  /** Available permission groups */
  groups: string[] = [];

  /** Form representation of the component */
  form: FormGroup;

  /** Injected data to the dialog */

  /**
   * Default constructor to initialize services and fetch permission groups
   * 
   * @param _userService for user-related operations
   * @param _http for HTTP requests
   */
  constructor(
    private _http: HttpClient,
    private _dialogRef: MatDialogRef<PermissionGroupDialogComponent>,
    private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { name: string },
  ) {
    // Fetch permission groups from the API
    this._http.get<string[]>(environment.baseUrl + '/users/groups').subscribe(
      (data: string[]) => {
        this.groups = data;
      });

    // Build the form
    this.form = this._fb.group({
      group: [null, Validators.required],
    });
  }

  /**
   * Submit the dialog and return the selected group
   */
  submit(): void {
    this._dialogRef.close(this.form.get('group')?.value);
  }

  /**
   * Close the dialog without any action
   */
  close(): void {
    this._dialogRef.close(null);
  }
}
